import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AboutScreen   from './screens/public/AboutScreen';
import PrivacyScreen from './screens/public/PrivacyScreen';
import TermsScreen   from './screens/public/TermsScreen';

// Static-feeling public pages, resolved by URL path before the authenticated
// app ever mounts. These must stay reachable with no Google sign-in for
// OAuth consent screen branding verification (see docs/deployment.md).
const PUBLIC_PAGES = {
  '/about':   AboutScreen,
  '/privacy': PrivacyScreen,
  '/terms':   TermsScreen,
};

const PublicPage = PUBLIC_PAGES[window.location.pathname];

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {PublicPage ? <PublicPage /> : <App />}
  </React.StrictMode>
);
